var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAacoLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".r{fill:url(#k);}.s{fill:#8bc53f;}.t{fill:#fff;}.u{fill:url(#c);}.v{fill:url(#d);}.w{fill:url(#l);}.x{fill:url(#h);}.y{fill:url(#o);}.z{fill:url(#j);}.aa{fill:url(#g);}.ab{fill:url(#q);}.ac{fill:url(#m);}.ad{fill:url(#e);}.ae{fill:url(#i);}.af{fill:url(#f);}.ag{fill:url(#p);}.ah{fill:url(#b);}.ai{fill:url(#n);}.aj{fill:#262261;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 27.6886,
    y1: 27.1525,
    x2: 27.6886,
    y2: 13.9771,
    gradientTransform: "translate(0 50) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8bc53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cbebfb",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 26.3564,
    cy: 24.6717,
    fx: 26.3564,
    fy: 24.6717,
    r: 11.2279,
    gradientTransform: "translate(.0847 49.9252) scale(.9968 -.9968)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0018,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1523,
    stopColor: "#fffacb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#cbe28c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3602,
    stopColor: "#8bc53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4354,
    stopColor: "#65bd44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5143,
    stopColor: "#44b648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5573,
    stopColor: "#37b34a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9892,
    stopColor: "#007035"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 29.1762,
    y1: 25.9083,
    x2: 35.8462,
    y2: 16.9153,
    gradientTransform: "translate(0 50) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00adee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cbebfb",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 28.8103,
    cy: 25.5477,
    fx: 28.8103,
    fy: 25.5477,
    r: 10.735,
    gradientTransform: "translate(.0847 49.9252) scale(.9968 -.9968)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0018,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1523,
    stopColor: "#b9e0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2469,
    stopColor: "#7abbe1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3602,
    stopColor: "#298dcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5002,
    stopColor: "#2a63ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    stopColor: "#2b4291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7079,
    stopColor: "#2b3587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282561"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 27.8933,
    y1: 26.662,
    x2: 37.8001,
    y2: 26.662,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 30.3756,
    cy: 29.0111,
    fx: 30.3756,
    fy: 29.0111,
    r: 8.3227,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 27.1557,
    y1: 32.8886,
    x2: 30.916,
    y2: 32.8886,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 26.3498,
    cy: 28.7487,
    fx: 26.3498,
    fy: 28.7487,
    r: 7.6592,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 23.7013,
    y1: 28.6577,
    x2: 23.7013,
    y2: 39.6171,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 26.0767,
    cy: 30.884,
    fx: 26.0767,
    fy: 30.884,
    r: 6.6668,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 21.6864,
    y1: 29.96,
    x2: 14.055,
    y2: 37.4313,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: 18.917,
    cy: 28.898,
    fx: 18.917,
    fy: 28.898,
    r: 13.1856,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 22.2573,
    y1: 27.6771,
    x2: 11.0937,
    y2: 27.6771,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: 21.9749,
    cy: 29.5108,
    fx: 21.9749,
    fy: 29.5108,
    r: 11.8572,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 23.3265,
    y1: 23.6565,
    x2: 16.066,
    y2: 16.5329,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "q",
    cx: 23.4254,
    cy: 25.7625,
    fx: 23.4254,
    fy: 25.7625,
    r: 9.0476,
    xlinkHref: "#e"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 48,
    height: 48
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M34.1681,23.4019c.299,0,.5981.2991.6978.5981.0997.299,0,.5981-.299.5981s-.5981-.299-.6978-.5981c-.0997-.2991,0-.5981.299-.5981Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M30.6791,17.0222c.299,0,.5981.2991.6978.5981s-.0997.4984-.3987.4984-.5981-.2991-.6978-.5981.0997-.4984.3987-.4984Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M24.0003,13.3339c.299,0,.6978.2991.6978.5981.0997.2991-.0997.4984-.3987.4984s-.6978-.2991-.7975-.5981c0-.2991.1994-.4984.4984-.4984Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M17.3215,14.6297c.3987,0,.6978.2991.7975.6978.0997.2991-.1994.5981-.4984.5981-.3987,0-.7975-.2991-.7975-.6978-.0997-.3987.1994-.6978.4984-.5981Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M14.8295,21.1092c.3987,0,.7975.2991.8972.6978.0997.3987-.1994.6978-.5981.6978s-.7975-.2991-.8972-.6978c-.0997-.3987.1994-.6978.5981-.6978Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M18.8168,28.7848c.3987,0,.7975.299.8972.6978.0997.3987-.1994.7975-.5981.7975s-.7975-.299-.8972-.6978c-.0997-.4984.1994-.7975.5981-.7975Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M26.9909,33.6693c-.3987-.299-.4984-.7975-.299-1.0965.1994-.299.5981-.3987.9968-.0997s.4984.7975.299,1.0965c-.0997.299-.5981.299-.9968.0997Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M32.9719,30.8782c-.299-.299-.4984-.6978-.299-.9968s.4984-.299.8972-.0997c.299.299.4984.6978.299.9968-.1994.2991-.5981.2991-.8972.0997Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M23.9007,28.9842s.8972-2.3924,2.3924-2.2927c1.9937.0997,4.4858,6.6788,5.1835,10.6661-.0997,0-3.3892-8.0744-7.5759-8.3734Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M28.5858,29.0839s-1.1962-2.3924-2.4921-2.3924c-.4984,0-.9968.299-1.5949,1.0965,0,0-3.3892,5.1835-2.4921,11.962.0997,0,3.1899-10.4668,6.5791-10.6661Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M29.0842,29.1835s-1.1962-2.5918-.3987-3.5886c1.0965-1.2959,6.4794,2.3924,9.1709,4.9842-.0997.0997-6.5791-3.9873-8.7722-1.3956Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M31.4766,25.9937s-2.193-1.1962-2.7911-.299c-.299.299-.299.9968-.0997,1.9937,0,0,1.894,6.4794,6.4794,10.6661,0,.0997-5.0839-9.769-3.5886-12.3608Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M31.7757,25.7943s-2.2927-1.3956-2.5918-2.7911c-.3987-1.894,4.7848-2.3924,7.5759-1.9937,0,.0997-5.682.9968-4.9842,4.7848Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M30.7788,21.4082s-1.894.4984-1.5949,1.6946c.0997.4984.4984,1.0965,1.3956,1.7943,0,0,4.9842,3.9873,9.4699,4.1867,0,0-8.2737-4.4858-9.2706-7.6756Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M30.8785,21.0095s-2.0934.3987-3.1899-.5981c-1.5949-1.4953.6978-5.682,2.3924-7.2769,0,0-2.193,4.9842.7975,7.875Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M27.3896,17.8196s-.5981,1.894.3987,2.6915c.3987.3987.9968.5981,1.9937.6978,0,0,4.9842,0,7.2769-2.7911-.0997-.0997-6.9778,1.5949-9.6693-.5981Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M26.9909,17.3212s-.7975,1.894-2.0934,1.6946c-1.9937-.2991-4.1867-6.0807-4.4858-9.1709,0,.0997,2.7911,6.8782,6.5791,7.4763Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M22.6048,16.7231s1.1962,2.193,2.2927,2.3924c.4984,0,.9968-.1994,1.4953-.7975,0,0,2.5918-3.5886,1.6946-7.9747,0,0-2.2927,6.5791-5.4826,6.3797Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M22.0067,16.6234s1.0965,2.3924.1994,3.2896c-1.2959,1.1962-7.4763-2.9905-10.4668-5.8813,0,0,7.5759,4.7848,10.2674,2.5918Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M19.1159,19.3149s2.4921,1.2959,3.1899.4984c.2991-.2991.3987-.8972.1994-1.894,0,0-1.4953-5.5823-5.8813-9.6693,0,.0997,4.3861,8.8718,2.4921,11.0649Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M18.7171,19.5142s2.5918,1.4953,2.7911,2.9905c.2991,2.0934-6.5791,2.9905-10.9652,2.4921,0,0,8.5728-1.2959,8.1741-5.4826Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M19.4149,24.299s2.3924-.6978,2.0934-1.894c-.0997-.4984-.4984-1.0965-1.3956-1.894,0,0-5.682-4.3861-12.1614-5.3829-.0997,0,10.6661,5.682,11.4636,9.1709Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M19.3152,24.7975s2.5918-.5981,3.8877.5981c1.7943,1.5949-1.0965,7.3766-3.788,10.2674,0,0,3.4889-7.4763-.0997-10.8655Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M23.5019,28.5854s.6978-2.2927-.2991-3.1899c-.3987-.3987-1.0965-.5981-2.2927-.6978,0,0-6.8782.1994-11.4636,4.4858-.0997,0,10.8655-3.1899,14.0554-.5981Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAacoLogoIcon);
export default __webpack_public_path__ + "static/media/aaco-logo-icon.f1cd8ed7bdda0328a17e78a9f6361c4b.svg";
export { ForwardRef as ReactComponent };